import { IRootState } from '../../../store'
import { IRulesOptionsState } from '../store/options.types'

export const getRulesOptionsSelector = (state: IRootState): IRulesOptionsState => state.options.rulesOptions
export const getRulesUtilsModuleSelector = (state: IRootState): any => state.options.rulesOptions.rulesUtilsModule
